var map = {
	"./event-2023-09-29-studio-carre.jpg": 987,
	"./event-2024-fusion-blues.jpg": 988,
	"./event-atelier-mensuel-edition-speciale.jpg": 989,
	"./event-atelier-mensuel-pratique.jpg": 990,
	"./event-atelier-mensuel.jpg": 991,
	"./event-atelier-ms-fevrier-2025.jpg": 705,
	"./event-atelier-ms-mai-2025.jpg": 710,
	"./event-atelier-ms-octobre-2024.jpg": 716,
	"./event-atelier-solo-blues.jpg": 992,
	"./event-balboa-day.jpg": 993,
	"./event-ete-oh-parc.jpg": 994,
	"./event-fusion-straciatella-2025.jpg": 723,
	"./event-grand-bal-janvier-2025.jpg": 728,
	"./event-grand-bal-ms.jpg": 995,
	"./event-petit-et-grand-bal-ms-mai-2025.jpg": 730,
	"./event-propulse-balboa.jpg": 996,
	"./event-session-coaching-2024.jpg": 997,
	"./event-session-thematique.jpg": 998,
	"./event-session-thematique2.jpg": 999,
	"./event-session-thematique3.jpg": 1000,
	"./event-soiree-fusion-10-2024.jpg": 1001,
	"./event-solo-venere-avril-juin-2025.jpg": 1002,
	"./event-solo-venere-janv-mars-2025.jpg": 1003,
	"./event-swing-apero-teasing.jpg": 1004,
	"./session-thematique-5-soloVenere.jpg": 1005
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 776;